import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";

export { }

declare global {
    interface Date {
        toNgbDateStruct(): NgbDateStruct;
        toNgbTimeStruct(): NgbTimeStruct;
        toSwedishUTCDate(): Date;
        getWeekNumber(): number;
    }
}

Date.prototype.toNgbDateStruct = function () {
    return { year: this.getFullYear(), month: this.getMonth() + 1, day: this.getDate() } as NgbDateStruct;
}

Date.prototype.toNgbTimeStruct = function () {
    return { hour: this.getHours(), minute: this.getMinutes(), second: this.getSeconds() } as NgbTimeStruct;
}

Date.prototype.toSwedishUTCDate = function () {
    if (this) {
        const localeDatum = this?.toLocaleString("sv-SE");
        return new Date(localeDatum + "Z");
    }
    else return this;
}

// ISO 8601-vecka (vecka 1 är den vecka som innehåller årets första torsdag)
Date.prototype.getWeekNumber = function () {
    const date = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
    const dayOfWeek = date.getUTCDay() || 7; // Måndag = 1, söndag = 7
    date.setUTCDate(date.getUTCDate() + 4 - dayOfWeek); // Torsdag samma vecka
    const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    return Math.ceil(((date.getTime() - yearStart.getTime()) / (24 * 60 * 60 * 1000) + 1) / 7);
}

export function evalFunction(expression: string, argNames: string[] = []): any
{
    return Function(...argNames, `return ${expression}`) as any;
}
